import { render, staticRenderFns } from "./StockInvoiceStakeholderDocuments.vue?vue&type=template&id=6f314e7c&scoped=true&"
import script from "./StockInvoiceStakeholderDocuments.vue?vue&type=script&lang=js&"
export * from "./StockInvoiceStakeholderDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StockInvoiceStakeholderDocuments.vue?vue&type=style&index=0&id=6f314e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f314e7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VIcon,VSimpleTable})
